import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/InlineForm/InlineFormTimelineItem.tsx
import { useState } from "react";
import { InlineForm } from "./InlineForm.mjs";
import { jsx } from "react/jsx-runtime";
function InlineFormTimelineItem({
  fields,
  title,
  submitLabel,
  isDismissed = false,
  onSubmit,
  onDismiss,
  dashboardMode = false,
  readOnly = false
}) {
  const [outcome, setOutcome] = useState("pending");
  if (!fields.length) return null;
  const dismissed = isDismissed || outcome === "dismissed";
  const settled = dashboardMode || dismissed || readOnly || outcome === "submitted" || fields.some((f) => f.value != null);
  const handleSubmit = async (values) => {
    await onSubmit?.(values);
    setOutcome("submitted");
  };
  const handleDismiss = onDismiss ? () => {
    setOutcome("dismissed");
    onDismiss();
  } : void 0;
  return /* @__PURE__ */ jsx("div", { className: `buyscout-timeline-inline-form${settled ? " buyscout-timeline-inline-form--completed" : ""}`, children: /* @__PURE__ */ jsx(
    InlineForm,
    {
      fields,
      title,
      submitLabel,
      isDismissed: dismissed,
      onSubmit: handleSubmit,
      onDismiss: handleDismiss,
      dashboardMode,
      readOnly
    }
  ) });
}
export {
  InlineFormTimelineItem
};
//# sourceMappingURL=InlineFormTimelineItem.mjs.map